import i18n from 'services/base/i18n';

export default {
  ok:         () => i18n.pgettext('Components|List History|Filter History|Action Input', 'OK'),
  checkAll:   () => i18n.pgettext('Components|List History|Filter History|Action Input', 'Select All'),
  uncheckAll: () => i18n.pgettext('Components|List History|Filter History|Action Input', 'Unselect All'),
};
